import { Pagination as PaginationMUI } from "@mui/material";
import { useCallback } from "react";

const SIZE_DEFAULT = 5;
export type PaginationProps = {
  total?: number;
  page?: number;
  size?: number;
  setPage: (value: number) => void;
};

export const Pagination = (props: PaginationProps) => {
  const { setPage, page, size, total } = props;

  const onChangePage = useCallback(
    (page: number) => {
      setPage(page);
    },
    [setPage]
  );

  return (
    (!!total && (
      <PaginationMUI
        tabIndex={page}
        count={Math.ceil((total || 0) / (size || SIZE_DEFAULT))}
        color="primary"
        page={page}
        defaultPage={page}
        onChange={(_e, val) => {
          onChangePage(val);
        }}
        sx={{
          justifyContent: "center",
          display: "flex",
          mt: 1,
        }}
      />
    )) ||
    null
  );
};
